export const CONTENT_SYNC_THRESHOLD_SECS = 2; //when the current time difference between speaker and content players exceed this, they will get synchronized
export const MASTER_PLAYLIST_REFRESH_INTERVAL_SECS = 4;
export const MASTER_PLAYLIST_VERSION_REGEX = /#EXT-X-SESSION-DATA:DATA-ID="vbrick.version",VALUE="(\d+\.\d+)"/;
export const MAX_INVALID_SYNC_EXPECTED_CONTENT_TIME_COUNT = 10; //trigger recovery after this many invalid expected content time values during attempted sync
export const SECONDS_NUMBER_PRECISION = 3;
export const SPEAKER_PLAYLIST_CONTENT_TAG = 'vbrickcontent';
export const VG_CONFERENCE_DUAL_HLS_TYPE = 'vbrick/conference-dual';
export const VG_CONFERENCE_DUAL_PLAYBACK_EXTENSION = '.dual';
